module.exports = __webpack_public_path__ + "img/icon_3_34.a2605089.png";